import { defineStore } from "pinia";
import type { Notification } from "@/Domain/Notification";

export const useNotificationStore = defineStore("notification", {
  state: () => {
    return {
      handleNotification: (notification: Notification) => {},
    };
  },
  actions: {
    notify(notification: Notification) {
      this.handleNotification(notification);
    },
  },
});
